// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import { Turbo } from "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "bootstrap"

// Initialize Stimulus
import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

window.Stimulus = Application.start()
const context = require.context("../controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

import "trix"
import "@rails/actiontext"

require("jquery")
require("easy-autocomplete")

import "../packs/assets"
import "../packs/contact_types"
import "packs/sort"
import "../packs/cash_pannel"
import "../packs/inline_rating_editor"
import "../packs/session_timeout"
import "../modules/document_folders"

import "chartkick/chart.js"
import "chartkick"

import Sortable from "sortablejs";

window.Sortable = Sortable;
window.bootstrap = bootstrap;

Rails.start()
ActiveStorage.start()
Turbo.start()

import 'bootstrap-icons/font/bootstrap-icons.css'

import * as bootstrap from 'bootstrap'
import "../stylesheets/application"

import {initKanbanSortable} from "../plugins/initSortable";
import {initColumnSortable} from '../plugins/initColumnSortable';
import {initSortableFields} from '../plugins/initFieldsSortable';
import {initSortableTable} from '../plugins/initSortableTable';

// Import quick trades controller
import "../controllers/quick_trades_controller"
import "../modules/report_exports"
import { subscribeToExportsChannel } from "../channels/exports_channel"

const PROGRESS_TOKEN_COOKIE = 'progress_token';

function readProgressToken() {
    const match = document.cookie.match(new RegExp('(?:^|; )' + PROGRESS_TOKEN_COOKIE + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

function writeProgressToken(token) {
    document.cookie = `${PROGRESS_TOKEN_COOKIE}=${token}; path=/`;
    window.currentProgressToken = token;
}

function generateProgressToken() {
    if (window.crypto && window.crypto.randomUUID) {
        return window.crypto.randomUUID();
    }
    return `pt-${Math.random().toString(36).slice(2)}${Date.now()}`;
}

window.currentProgressToken = readProgressToken();

document.addEventListener("turbo:before-visit", function () {
    //Turbo.clearCache();
    let currentUserId = document.querySelector("body").getAttribute("data-current-user-id");
    if (currentUserId) {
        subscribeToProgressChannel(currentUserId);
        subscribeToExportsChannel(currentUserId);
    }
});

document.addEventListener("turbo:before-visit", function () {
    let currentUserId = document.querySelector("body").getAttribute("data-current-user-id");
    if (!currentUserId) {
        return;
    }

    const activeToken = window.currentProgressToken || readProgressToken();
    if (activeToken) {
        cancelConsolidationProcessing(activeToken);
    }

    const newToken = generateProgressToken();
    writeProgressToken(newToken);
    subscribeToProgressChannel(currentUserId);
});

window.addEventListener('beforeunload', function () {
    const activeToken = window.currentProgressToken || readProgressToken();
    if (activeToken) {
        cancelConsolidationProcessing(activeToken);
    }
});

document.addEventListener("turbo:load", function () {
    let currentUserId = document.querySelector("body").getAttribute("data-current-user-id");
    if (currentUserId) {
        subscribeToProgressChannel(currentUserId);
        subscribeToExportsChannel(currentUserId);
    }
    window.currentProgressToken = readProgressToken();
});

document.addEventListener('turbo:load', fetchHistoricCash);

function setOverlaySpinnerVisibility(overlayElement, isVisible) {
    if (!overlayElement) {
        return;
    }
    const spinnerElements = overlayElement.querySelectorAll('[data-overlay-spinner]');
    spinnerElements.forEach(function (spinner) {
        if (isVisible) {
            spinner.classList.remove('d-none');
        } else {
            spinner.classList.add('d-none');
        }
    });
}

function updateMenuOverlayState(overlayElement, feedbackElement) {
    if (!overlayElement) {
        return;
    }
    const totalCount = parseInt(overlayElement.dataset.overlayActiveCount || '0', 10);
    const menuCount = parseInt(overlayElement.dataset.menuDropdownCount || '0', 10);

    const menuOnlyOverlay = menuCount > 0 && totalCount === menuCount;

    if (menuOnlyOverlay) {
        overlayElement.classList.add('overlay--menu-dropdown');
        document.body.classList.add('menu-dropdown-open');
        if (feedbackElement && feedbackElement.length) {
            feedbackElement.addClass('d-none');
        }
    } else {
        overlayElement.classList.remove('overlay--menu-dropdown');
        document.body.classList.remove('menu-dropdown-open');
    }

    setOverlaySpinnerVisibility(overlayElement, !menuOnlyOverlay);
}

function showOverlay(reason) {
    const overlayElement = document.getElementById('overlay');
    if (!overlayElement) {
        return;
    }
    const overlay = $('#overlay');
    const feedbackElement = $('#process-feedback');

    const activeCount = parseInt(overlayElement.dataset.overlayActiveCount || '0', 10) + 1;
    overlayElement.dataset.overlayActiveCount = activeCount;

    if (reason === 'menu-dropdown') {
        const menuCount = parseInt(overlayElement.dataset.menuDropdownCount || '0', 10) + 1;
        overlayElement.dataset.menuDropdownCount = menuCount;
    }

    if (reason !== 'menu-dropdown') {
        feedbackElement.html("");
    }
    updateMenuOverlayState(overlayElement, feedbackElement);
    overlay.stop(true, true).fadeIn();
}

function hideOverlay(reason) {
    const overlayElement = document.getElementById('overlay');
    if (!overlayElement) {
        return;
    }
    const overlay = $('#overlay');
    const feedbackElement = $('#process-feedback');

    const previousCount = parseInt(overlayElement.dataset.overlayActiveCount || '0', 10);
    const currentCount = Math.max(0, previousCount - 1);

    if (currentCount === 0) {
        delete overlayElement.dataset.overlayActiveCount;
    } else {
        overlayElement.dataset.overlayActiveCount = currentCount;
    }

    if (reason === 'menu-dropdown') {
        const previousMenuCount = parseInt(overlayElement.dataset.menuDropdownCount || '0', 10);
        const currentMenuCount = Math.max(0, previousMenuCount - 1);

        if (currentMenuCount === 0) {
            delete overlayElement.dataset.menuDropdownCount;
        } else {
            overlayElement.dataset.menuDropdownCount = currentMenuCount;
        }
    }

    updateMenuOverlayState(overlayElement, feedbackElement);

    if (currentCount === 0) {
        overlay.stop(true, true).fadeOut();
        // Add a delay before hiding the overlay (e.g., 1000ms = 1 second)
        setTimeout(function () {
            feedbackElement.addClass('d-none');
            feedbackElement.html("");
        }, 1000); // You can adjust the delay time according to your preference
    }
}

window.showOverlay = showOverlay;
window.hideOverlay = hideOverlay;

document.addEventListener("turbo:before-visit", function () {
    showOverlay();
});

document.addEventListener("turbo:load", function () {
    hideOverlay();
});

document.addEventListener('turbo:before-cache', function () {
    document.querySelectorAll('.modal.show').forEach(function (modalElement) {
        const instance = bootstrap.Modal.getInstance(modalElement);
        if (instance) {
            instance.hide();
        }
        modalElement.classList.remove('show');
    });
});

document.addEventListener('ready', function () {
    hideOverlay();
});

document.addEventListener('turbo:load', function () {

    // Show the correct tab
    var hash = location.hash.replace(/^#/, '');
    if (hash) {
        $('[data-bs-toggle="pill"][href="#' + hash + '"], [data-bs-toggle="tab"][href="#' + hash + '"]').tab('show');
    }

    $('[data-bs-toggle="pill"], [data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
        if (e.target.hash) {
            window.location.hash = e.target.hash;
        }
    })


    const kanbanUls = document.querySelectorAll(".kanban .kanban-col-content");
    if (kanbanUls) {
        initKanbanSortable(kanbanUls);
    }

    const kanbanCols = document.querySelector('.kanban-cols');
    if (kanbanCols) {
        initColumnSortable();
    }

    const contactTypes = document.querySelector('#sortable-fields');
    if (contactTypes) {
        initSortableFields();
    }

    const tableSortableThs = document.querySelector('.sortable-ths');
    if (tableSortableThs) {
        initSortableTable();
    }

    var toastElList = [].slice.call(document.querySelectorAll('.toast'))
    var toastList = toastElList.map(function (toastEl) {
        return new bootstrap.Toast(toastEl).show()
    })

    $(".colored-number").each(function () {
        if ($(this).text().replace(/'/g, "") < 0) {
            $(this).css("color", "red")
        }
    });
    $(".colored-number").each(function () {
        if ($(this).text().replace(/'/g, "") > 0) {
            $(this).css("color", "green")
        }
    });


    activateTooltips();

    function activateTooltips() {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        })
    }

    searchForm();

    function searchForm() {
        let $input;
        $input = $('*[data-behavior="autocomplete-navbar"]');

        const escapeRegex = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        const extractTerms = () => {
            const raw = ($input.val() || "").toLowerCase();
            const terms = raw.split(/\s+/).map(term => term.trim()).filter(Boolean);
            return [...new Set(terms)];
        };

        const highlightTerms = (text, terms) => {
            if (!text) {
                return text;
            }

            const uniqueTerms = [...new Set(terms)].sort((a, b) => b.length - a.length);
            if (!uniqueTerms.length) {
                return text;
            }

            const pattern = uniqueTerms.map(escapeRegex).join("|");
            const regex = new RegExp(`(${pattern})`, "gi");

            return String(text).replace(regex, "<strong>$1</strong>");
        };

        var options = {
            url: function (phrase) {
                return "/search.json?q=" + phrase;
            },
            adjustWidth: false,
            getValue: "name",
            theme: $('body').data('theme'),
            template: {
                type: "custom",
                method: function (value, item) {
                    const terms = extractTerms();
                    const typeLabel = item.type || "";
                    const highlightedValue = highlightTerms(value, terms);
                    const typeSection = typeLabel
                        ? "<span class='text-muted'>" + highlightTerms(typeLabel, terms) + " | </span>"
                        : "";
                    return typeSection + highlightedValue;
                }
            },
            list: {
                maxNumberOfElements: 20,
                onChooseEvent: function () {
                    let selected = $input.getSelectedItemData();
                    Turbo.visit(selected.link);
                    $('#searchModal').modal('hide');
                    $('#overlay').fadeIn();
                }
            }
        };

        $input.easyAutocomplete(options);

        $('.search-form').on('keypress', e => {
            if (e.keyCode == 13) {
                return false;
            }
        });
    }

    // Best in place error handling for locked investments
    $(document).on('best_in_place:error', function(event, request, error) {
        // Try to parse the error response
        let errorMessage = 'An error occurred while updating.';

        try {
            const response = JSON.parse(request.responseText);
            if (response.error) {
                errorMessage = response.error;
            } else if (response.errors) {
                errorMessage = Object.values(response.errors).flat().join(', ');
            }
        } catch(e) {
            // If we can't parse JSON, try to extract from HTML
            if (request.responseText) {
                errorMessage = request.responseText;
            }
        }

        // Show alert using Bootstrap toast or alert
        showErrorAlert(errorMessage);
    });

    function showErrorAlert(message) {
        // Create a Bootstrap alert
        const alertHtml = `
            <div class="alert alert-danger alert-dismissible fade show position-fixed top-0 start-50 translate-middle-x mt-3"
                 role="alert"
                 style="z-index: 9999; max-width: 600px;">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                <strong>Error:</strong> ${message}
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
        `;

        // Append to body
        $('body').append(alertHtml);

        // Auto-dismiss after 5 seconds
        setTimeout(function() {
            $('.alert').fadeOut(500, function() {
                $(this).remove();
            });
        }, 5000);
    }
});
